import { TypedResult } from 'onboarding/types/result'

export function tryCatchSync<T, E = Error>(callback: () => T): TypedResult<T, E> {
  try {
    return { data: callback(), error: null }
  } catch (e: any) {
    return { data: null, error: e }
  }
}

export async function tryCatchAsync<T, E = Error>(promise: Promise<T>): Promise<TypedResult<T, E>> {
  try {
    return { data: await promise, error: null }
  } catch (e: any) {
    return { data: null, error: e }
  }
}
